import type { RouteRecordRaw } from 'vue-router'

const exportRoutes: RouteRecordRaw[] = [
  {
    path: '/export',
    component: () => import('@/layouts/app/layout-app.vue'),
    children: [
      {
        path: '',
        name: 'export master',
        component: () => import('@/views/export/page-export-master.vue'),
      },
      {
        path: 'shop',
        name: 'export shop',
        component: () => import('@/views/export/page-export-shop.vue'),
      },
      {
        path: 'microfinance',
        name: 'export microfinance',
        component: () => import('@/views/export/page-export-microfinance.vue'),
      },
      {
        path: 'salary-deduction',
        name: 'export salary deduction',
        component: () => import('@/views/export/page-export-salary-deduction.vue'),
      },
      {
        path: 'import',
        alias: 'upload-massal',
        name: 'import',
        component: () => import('@/views/export/page-upload-massal.vue'),
      },
      {
        path: 'upload-massal',
        name: 'upload massal',
        redirect: { name: 'import' },
      },
    ],
  },
]

export { exportRoutes }
